export default {
    nav: {
        home: '首页',
        contact: '联系方式',
        about: '关于我们',
        join: '人才招聘',
        dataService: '数据服务'
    },
    button: {
        login: '会员登录',
        logout: '退出',
        openLogin: '打开登录窗口'
    },
    message: {
        loginRequired: '请先登录',
        loginStatusChanged: '导航栏监听到登录状态变化:',
        debugJumpTo: '[调试] 跳转至:',
        eventBusError: '事件总线未注册，请在main.js中添加: Vue.prototype.$bus = new Vue()'
    },
    footer: {
        about: '关于我们',
        philosophy: '公司理念',
        contact: '联系方式',
        careers: '人才招聘',
        copyright: 'Copyright © 2009-2098 www.meituodata.com All Rights Reserved.',
        icp: '浙ICP备20027945号-1',
        phone: '联系电话：18969418571(微信同号)',
        address: '地址：杭州市西湖区古墩路387号金桂大厦1406室'
    },
    el: {
        pagination: {
            total: '总计 {total}',
            goto: '跳转'
        },
        datepicker: {
            now: 'Now',
            today: 'Today',
            cancel: 'Cancel',
            clear: 'Clear',
            confirm: 'Confirm',
            selectDate: 'Select date',
            selectTime: 'Select time'
        }
    },
    home_page:{
        item_data: "数据",
        items: "条",
        export: "导出",
        export_page: "当前页",
        export_all: "全部记录",
        export_last_time: "数据更新至",
        advanced_search: "高级搜索",
        advanced_search_add: "添加筛选条件",
        advanced_search_condition: "搜索条件",
        advanced_search_result: "总记录",
        advanced_search_button: "搜索",
        advanced_search_reset_button: "重置",
        advanced_search_loading: "数据加载中"
    },
    index: {
        banner: {
            title: "专注医药信息服务",
            content: "10多年行业经验，专业数据支持。全球展会参与 CPHI、API、CAC、FIC等国际展会。专业数据分析 真实有效、真诚专业的市场咨询。专业数据服务 真实有效、真诚专业的市场咨询。",
            images: [
                "/img/bg1.jpg", // 实验室场景图
                "/img/bg2.jpg", // 医药展会现场
                "/img/bg3.jpg"  // 数据分析图表
            ]
        },
        company: {
            name: "杭州美拓医药科技有限公司",
            intro: "坐落于美丽西子湖畔杭州的医药信息公司，专注、专业从事医药、农药、生物、化工等信息数据服务。为广大国内外客户提供真实有效、真诚专业的数据信息和市场咨询。",
            experience: "公司专注医药化工行业10多年，和国内绝大部分医药出口企业建立良好联系与合作，常年参加CPHI、API、CAC、FIC等展会。"
        },
        services: {
            title: "核心服务",
            data: {
                title: "数据信息服务",
                desc: "提供医药、农药、生物、化工等行业的专业数据信息，助力客户决策"
            },
            consulting: {
                title: "市场咨询",
                desc: "真诚专业的市场分析与咨询服务，为企业发展提供战略支持"
            },
            cooperation: {
                title: "企业合作对接",
                desc: "连接国内外医药企业，促进技术交流与商业合作"
            },
            exhibition: {
                title: "展会服务",
                desc: "提供国际展会参展支持，拓展企业全球视野"
            }
        },
        exhibitions: {
            title: "国际展会参与",
            cphi: {
                name: "CPHI 全球医药原料展",
                desc: "全球领先的医药原料及制药设备展览会"
            },
            api: {
                name: "API China 中国国际原料药展",
                desc: "中国制药原料行业的盛会"
            },
            cac: {
                name: "CAC 中国国际农用化学品及植保展览会",
                desc: "全球领先的农用化学品专业展览会"
            },
            fic: {
                name: "FIC 中国国际食品添加剂和配料展览会",
                desc: "亚洲领先的食品添加剂和配料专业展会"
            }
        },
        clients: {
            title: "合作客户",
            desc: "与国内绝大部分医药出口企业建立良好联系与合作",
            list: ["客户企业 A", "客户企业 B", "客户企业 C", "客户企业 D", "客户企业 E", "客户企业 F"]
        },
        contact: {
            title: "联系我们",
            email: "邮箱"
        }
    },
    contact: {
        title: "联系我们",
        subtitle: "我们期待与您建立联系，为您提供专业的医药信息服务",
        contactInfo: "联系方式",
        companyName: "公司名称",
        phone: "联系电话",
        phone_detail: "18969418571(微信同号)",
        address: "公司地址",
        address_detail: "杭州市西湖区古墩路387号金桂大厦1406室",
        email: "电子邮箱",
        workingHours: "工作时间",
        weekdays: "周一至周五: 9:00 - 18:00",
        weekends: "周六至周日: 休息",
        advantages: "我们的优势",
        dataService: "专业数据服务",
        dataServiceDesc: "10多年医药行业数据积累，提供精准、全面的市场分析",
        customerResources: "优质客户资源",
        customerResourcesDesc: "与国内绝大部分医药出口企业建立长期稳定合作关系",
        internationalVision: "国际视野",
        internationalVisionDesc: "常年参与国际知名医药展会，掌握全球市场动态",
        professionalTeam: "专业团队",
        professionalTeamDesc: "拥有一支经验丰富、专业素养高的医药信息服务团队",
        process: "合作流程",
        step1: "需求咨询",
        step1Desc: "客户提出需求，我们提供初步咨询服务",
        step2: "方案定制",
        step2Desc: "根据客户需求，制定个性化服务方案",
        step3: "合作签约",
        step3Desc: "双方确认合作细节，签订服务合同",
        step4: "项目执行",
        step4Desc: "专业团队按计划执行服务项目",
        step5: "售后跟进",
        step5Desc: "定期回访，提供持续技术支持",
        testimonials: "客户评价",
        testimonial1: "\"美拓医药提供的市场数据分析报告非常专业，帮助我们及时把握了行业动态，为公司决策提供了有力支持。某大型医药出口企业 市场部总监\"",
        testimonial1_company:"某大型医药出口企业",
        testimonial1_department:"市场部总监",
        testimonial2: "\"与美拓医药合作多年，他们的服务始终保持高水准，团队响应迅速，数据准确可靠，是我们值得信赖的合作伙伴。某生物科技公司 总经理\"",
        testimonial2_company:"某大型医药出口企业",
        testimonial2_department:"市场部总监",
        companyEnv: "公司环境",
        companyLocation: "公司位置",
        viewMap: "查看地图"
    },
    about: {
        pageTitle: "关于我们",
        pageSubtitle: "专注医药科技，引领行业创新",
        companyProfile: "公司简介",
        companyIntro: "杭州美拓医药科技有限公司成立于2010年7月30日，注册地位于杭州市拱墅区（原下城区）绍兴路161号野风现代中心南楼821室。",
        companyDesc: "公司专注于医药及医疗器械领域的技术开发与咨询服务，属于科学研究和技术服务业。我们致力于为客户提供专业、高效的医药信息解决方案，助力医药产业创新发展。",
        companyHistory: "经过多年发展，公司已与国内众多医药企业建立了稳定的合作关系，在行业内树立了良好的口碑和品牌形象。",
        coreTeam: "核心团队",
        member1Name: "文海燕",
        member1Title: "法定代表人、执行董事兼总经理",
        member1Share: "持股比例：80%",
        member1Bio: "负责公司整体战略规划和运营管理，拥有丰富的医药行业经验和管理经验。",
        member2Name: "贾晨希",
        member2Title: "监事",
        member2Share: "持股比例：20%",
        member2Bio: "负责公司监督管理工作，在医药技术领域拥有深厚的专业背景。",
        developmentHistory: "发展历程",
        timeline2010Title: "公司成立",
        timeline2010Desc: "杭州美拓医药科技有限公司于7月30日正式成立，注册地位于杭州市拱墅区绍兴路161号野风现代中心南楼821室。",
        timeline2015Title: "业务拓展",
        timeline2015Desc: "扩大业务范围，开始专注于医药及医疗器械领域的技术开发与咨询服务，与多家医药企业建立合作关系。",
        timeline2020Title: "行业认可",
        timeline2020Desc: "公司在医药信息服务领域获得广泛认可，成为多家知名医药企业的长期合作伙伴。",
        timeline2025Title: "持续发展",
        timeline2025Desc: "公司持续扩大服务范围，提升专业服务能力，致力于成为医药科技服务领域的领军企业。",
        companyVision: "公司愿景",
        mission: "使命",
        missionDesc: "通过专业的医药信息服务，助力医药产业创新发展，为人类健康事业贡献力量。",
        vision: "愿景",
        visionDesc: "成为国内领先的医药科技服务提供商，引领行业发展，创造更大价值。",
        values: "价值观",
        valuesDesc: "专业、诚信、创新、卓越，以客户为中心，以质量为生命。",
        basicInfo: "企业基本信息",
        infoName: "企业名称",
        infoDate: "成立时间",
        infoAddress: "注册地址",
        infoBusiness: "经营范围",
        infoType: "企业类型",
        infoValueName: "杭州美拓医药科技有限公司",
        infoValueDate: "2010年7月30日",
        infoValueAddress: "杭州市拱墅区（原下城区）绍兴路161号野风现代中心南楼821室",
        infoValueBusiness: "医药及医疗器械领域的技术开发与咨询服务",
        infoValueType: "自然人投资或控股的有限责任公司"
    },
    careers: {
        pageTitle: "加入美拓医药，共创医药科技美好未来",
        jobTitle: "岗位名称",
        jobDuties: "岗位职责",
        jobRequirements: "任职要求",
        jobBonus: "加分项",
        jobBenefits: "待遇情况",
        contactUs: "联系我们",
        email: "招聘邮箱",
        emailNote: "邮件主题请注明：应聘岗位+姓名",
        phone: "联系电话",
        phone_detail: "18969418571(微信同号)",
        address: "公司地址",
        infoValueAddress: "杭州市拱墅区（原下城区）绍兴路161号野风现代中心南楼821室",
        jobs: [
            {
                title: "AI技术总监",
                duties: [
                    "负责公司AI技术的规划、设计、开发和实施，确保技术方案的可行性和有效性；",
                    "领导团队进行技术研究和开发，推动公司AI技术的不断创新和发展；",
                    "负责AI技术的应用和推广，提高公司在行业内的竞争力；",
                    "负责AI技术的维护和升级，确保系统的稳定性和安全性；",
                    "与公司其他部门紧密合作，协调技术资源，为公司业务发展提供技术支持。"
                ],
                requirements: [
                    "具有计算机、人工智能等相关专业本科及以上学历；",
                    "具有5年以上AI技术相关工作经验，有团队管理经验者优先考虑；",
                    "熟悉机器学习、深度学习、自然语言处理等AI技术，具有较强的技术研究和开发能力；",
                    "具有良好的沟通、协调和团队管理能力，能够有效地推动团队工作；",
                    "具有较强的学习能力和创新意识，能够不断学习和掌握新的技术和知识；",
                    "具有较强的责任心和执行力，能够承担工作压力和挑战。"
                ],
                bonus: ["有以下行业经验：企业服务·人工智能"],
                benefits: []
            },
            {
                title: "药剂科主任",
                requirements: [
                    "第一学历本科，博士研究生，正高级职称；",
                    "在高校附属医院、省级医院或三甲医院从事本专业工作8年及以上；",
                    "有科研成果、管理经验优先考虑；",
                    "年龄50周岁以内。"
                ],
                benefits: [
                    "收入：可谈年薪+科研激励+特聘人才津贴；",
                    "安家费：根据区人才引进政策评定；",
                    "科研启动金：面议；",
                    "提供人才住房及住房补贴；",
                    "协助解决爱人工作、孩子教育问题。"
                ],
                duties: [],
                bonus: []
            },
            {
                title: "药剂师",
                duties: [
                    "根据医师处方，将中药饮片调配成供顾客使用的药剂；",
                    "熟练识别中药饮片，熟悉中药配伍禁忌；",
                    "能自觉履行药师职责，按调剂规范调配处方；",
                    "能够独立完成审方、抓药、包药、煎药；负责药品的验收、质保、养护、库管等工作；",
                    "在药房主管的领导下开展药房相关工作；",
                    "有药房工作经验者优先；",
                    "服从安排，完成上级领导交办的其他工作。"
                ],
                requirements: [
                    "硬性要求：具有卫生系统颁发的中药师（士）资格证书，本科及以上学历；",
                    "药店从业经验1年以上或具有中药饮片调剂1年以上工作经历的优先考虑；",
                    "熟悉药品法律法规，独立完成岗位工作；",
                    "善于沟通，有亲和力，为人严谨细致，具有团队协作。"
                ],
                bonus: [],
                benefits: []
            },
            {
                title: "医药研发总监",
                duties: [
                    "负责建立药物设计平台，设计结构新颖具有知识产权的新分子结构，发现新药先导化合物并通过结构优化以获得临床前候选新药；",
                    "负责建立和维护药物合成平台、分析平台，确保合成、分析各项实验规范有序进行；",
                    "负责建立并完善创新药研发实验室管理体系及项目管理体系，确保创新药发现项目规范有序进行；",
                    "负责审核部门对外委托研究的合理性和必要性。负责专利相关部分的审核工作；",
                    "负责部门的日常管理工作。负责创新药研发一部的绩效考核工作及相关制度的制定。负责制定创新药研发一部人员培养及团队建设方案，确保在本部门实施执行；",
                    "负责部门与各部门间的协调和衔接，为项目管理提供必要的资源支持，确保各项目研发工作的顺利进行。负责与相关部门的协调和沟通，明确创新药研发一部研发项目的采购、审计、样品试制、检验、仓储等需求；",
                    "负责、落实部门安全管理制度和安全责任制，确保各项工作在安全的条件下进行，对创新药研发一部安全工作承担直接管理责任；",
                    "负责本部门的职业健康安全与环保管理工作，执行公司安委会的工作部署，认真落实安全生产及环境保护措施，并完成年度EHS管理目标；",
                    "负责完成上级领导安排的其它相关工作。"
                ],
                requirements: [
                    "学历：博士及以上；",
                    "专业：有机合成、药物化学及相关专业；",
                    "工作经验：10年及以上候选药物研发工作经验，担任过新药药学研发部门主管及以上职位，有5年及以上的新药药学研发管理工作经验。有海外创新药物研发背景可优先考虑；",
                    "专业知识/技能：掌握国家对创新药物研发的政策法规，熟悉创新药发现阶段研发流程，良好的协调、沟通、研发管理能力。掌握国内外的创新药物研发动态，精通药物化学分子设计与合成路线设计，精通专利要求，掌握药理、药代和毒理等相关药学专业知识；",
                    "语言要求：熟练阅读英文文献专利，具备良好的英文听说读写能力；",
                    "应具备的素质能力：良好的协调、沟通、研发管理能力；良好的动手能力及学习能力。有一定的抗压能力；爱岗敬业，有责任心；广泛的信息渠道、清晰的研发思路，准确的研发导向，果断的决策能力和良好的领导能力。"
                ],
                bonus: [],
                benefits: []
            }
        ]
    },
    lang: {
        'zh-CN': '中文',
        'en-US': '英文'
    }
};